import Task from './Task.view';

export default Task;
